import React, { useMemo } from 'react';
import { getCloudImageUrl } from 'utils';
import { NSKickImage } from './KickImage.d';
import { ImagePropTypes } from './KickImage.propTypes';

const KickImage: React.FC<NSKickImage.Props> = (props) => {
  const { src, cdnWidth, noCompress, isGifImage, ...otherProps } = props;

  const imageSource = useMemo(() => {
    const width = noCompress ? null : cdnWidth ?? 500;

    // If it's a gif image, we don't need to compress and use getCloudImageUrl
    if (isGifImage) {
      return src;
    }

    return getCloudImageUrl(src, width);
  }, [src]);

  return <img src={imageSource} {...otherProps} />;
};

KickImage.propTypes = ImagePropTypes;

export default KickImage;
